/**
 * Shared theme constants for consistent styling across all platforms
 * Aligned with marketing page design (soulthread.me)
 * Use these instead of hardcoded values
 */

export const colors = {
  // Brand colors (from marketing page)
  primary: '#6366f1', // Indigo - matches marketing
  secondary: '#8b5cf6', // Purple - matches marketing
  accent: '#ec4899', // Pink - matches marketing

  // Background colors (from marketing page)
  background: '#0a0118', // Very dark purple - matches marketing
  surface: '#1a0f2e', // Dark purple - matches marketing
  surfaceLight: '#2d1b4e', // Medium purple - matches marketing

  // Text colors (from marketing page)
  text: '#ffffff', // White - matches marketing
  textSecondary: '#a78bfa', // Light purple - matches marketing
  textMuted: '#6b7280', // Gray - matches marketing

  // Status colors
  success: '#10b981', // Emerald
  error: '#ef4444', // Red
  warning: '#f59e0b', // Amber
  info: '#3b82f6', // Blue

  // Gradient colors (from marketing page)
  gradient1: '#667eea', // Start of gradient
  gradient2: '#764ba2', // End of gradient
  gradient3: '#ec4899', // Accent gradient
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

export const borderRadius = {
  sm: 4,
  md: 8,
  lg: 12,
  xl: 16,
  xxl: 20,
  full: 9999,
};

export const fontSize = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 18,
  xl: 20,
  xxl: 24,
  xxxl: 28,
  display: 36,
};

export const fontWeight = {
  regular: '400' as const,
  medium: '500' as const,
  semibold: '600' as const,
  bold: '700' as const,
};

export const shadows = {
  sm: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  md: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 6,
    elevation: 3,
  },
  lg: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.15,
    shadowRadius: 15,
    elevation: 8,
  },
};
